import Box from "./Box";
import Link from "next/link";
import PropTypes from "prop-types";
import RadioButtonInner from "./RadioButtonInner";
import React from "react";

function RadioButtonLink({ active, label, href }) {
  return (
    <Link href={href} passHref>
      <Box as="a">
        <RadioButtonInner active={active} label={label} />
      </Box>
    </Link>
  );
}

export default RadioButtonLink;

RadioButtonLink.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};
